import(/* webpackMode: "eager", webpackExports: ["Inquiry"] */ "/codebuild/output/src1006553232/src/helloero-new/packages/help/src/app/(withLayout)/inquiry/(index)/_Inquiry/index.tsx");
